import React, { ReactNode, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import NavBar from '../NavBar';
import { Icons } from '@ohif/ui-next';

function Header({
  children,
  menuOptions,
  isReturnEnabled = true,
  onClickReturnButton,
  isSticky = false,
  Secondary,
  ...props
}: any): ReactNode {
  const { t } = useTranslation('Header');
  const [user, setUser] = useState<{ preferredName: string } | null>(null);

  // Fetch session details
  useEffect(() => {
    fetch('https://studies.clarify-pacs.com/session.php', {
      //fetch('http://38.242.140.57/pacs/session.php', {
      credentials: 'include', // Ensures cookies are sent
    })
      .then(res => res.json())
      .then(data => {
        if (data.user_id) {
          setUser(data);
        }
      })
      .catch(err => console.error('Error fetching session:', err));
  }, []);

  const onClickReturn = () => {
    if (isReturnEnabled && onClickReturnButton) {
      onClickReturnButton();
    }
  };
  const handleLogout = async () => {
    try {
      await fetch('https://studies.clarify-pacs.com/logout.php', {
        // await fetch('http://38.242.140.57/pacs/logout.php', {
        method: 'GET',
        credentials: 'include', // Ensure session cookies are handled
      });
      setUser(null); // Clear user state
      window.location.reload(); // Refresh the page
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <NavBar
      isSticky={isSticky}
      {...props}
    >
      <div className="relative flex h-[48px] items-center">
        {/* Left section with return icon */}
        <div className="absolute left-0 top-1/2 flex -translate-y-1/2 items-center">
          <div
            className={classNames(
              'mr-3 inline-flex items-center',
              isReturnEnabled && 'cursor-pointer'
            )}
            onClick={onClickReturn}
            data-cy="return-to-work-list"
          >
            {isReturnEnabled && <Icons.ChevronClosed className="text-primary-active w-8" />}
          </div>
        </div>

        {/* Secondary content */}
        <div className="absolute top-1/2 left-[250px] h-8 -translate-y-1/2">{Secondary}</div>

        {/* Centered content */}
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform">
          <div className="flex items-center justify-center space-x-2">{children}</div>
        </div>

        {/* Session Details */}

        <div className="absolute right-0 top-1/2 flex -translate-y-1/2 items-center space-x-4">
          <p className="text-[#23db0b]">{user ? `${user.preferredName}` : 'Guest User'}</p>
          {user ? (
            <span
              className="cursor-pointer text-red-500"
              onClick={handleLogout}
            >
              [Logout]
            </span>
          ) : (
            <a
              href="https://studies.clarify-pacs.com/index.php"
              // href="http://38.242.140.57/pacs/index.php"
              className="cursor-pointer text-red-500"
            >
              [Login]
            </a>
          )}
          ss
        </div>
      </div>
    </NavBar>
  );
}

Header.propTypes = {
  menuOptions: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      icon: PropTypes.string,
      onClick: PropTypes.func.isRequired,
    })
  ),
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  isReturnEnabled: PropTypes.bool,
  isSticky: PropTypes.bool,
  onClickReturnButton: PropTypes.func,
  Secondary: PropTypes.node,
};

export default Header;
